import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const SUPPORTED_LANGUAGES = [
  { code: "en-US", name: "English (US)", flag: "🇺🇸" },
  { code: "hi-IN", name: "हिन्दी (Hindi)", flag: "🇮🇳" },
  { code: "en-GB", name: "English (UK)", flag: "🇬🇧" },
  { code: "es-ES", name: "Español (Spanish)", flag: "🇪🇸" },
  { code: "fr-FR", name: "Français (French)", flag: "🇫🇷" },
  { code: "de-DE", name: "Deutsch (German)", flag: "🇩🇪" },
  { code: "ja-JP", name: "日本語 (Japanese)", flag: "🇯🇵" },
  { code: "zh-CN", name: "中文 (Chinese)", flag: "🇨🇳" },
  { code: "ar-SA", name: "العربية (Arabic)", flag: "🇸🇦" },
  { code: "he-IL", name: "עברית (Hebrew)", flag: "🇮🇱" },
  { code: "pt-BR", name: "Português (Brasil)", flag: "🇧🇷" },
  { code: "pt-PT", name: "Português (Portugal)", flag: "🇵🇹" },
];

export const LanguageProvider = ({ children }) => {
  // Initialize from localStorage or default to English
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("app_language");
    return savedLanguage || "en-US";
  });

  // Persist language changes to localStorage
  useEffect(() => {
    localStorage.setItem("app_language", language);
  }, [language]);

  const changeLanguage = (languageCode) => {
    setLanguage(languageCode);
  };

  const getCurrentLanguage = () => {
    return (
      SUPPORTED_LANGUAGES.find((lang) => lang.code === language) ||
      SUPPORTED_LANGUAGES[0]
    );
  };

  const getLanguageName = () => {
    const currentLang = getCurrentLanguage();
    return currentLang.name;
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        languageName: getLanguageName(),
        changeLanguage,
        getCurrentLanguage,
        supportedLanguages: SUPPORTED_LANGUAGES,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
